var map = {
	"./Ally+logo+resize(72).png": 3202,
	"./analytic-graph.png": 8899,
	"./bar-chart.png": 7045,
	"./disease.png": 5499,
	"./doc.png": 9080,
	"./drought.png": 1740,
	"./flood.png": 5677,
	"./image.png": 410,
	"./insecticide.png": 3289,
	"./line-graph (1).png": 2242,
	"./line-graph.png": 2976,
	"./main.png": 3790,
	"./music.png": 6588,
	"./pdf.png": 6831,
	"./pest(1).png": 8303,
	"./pest.png": 2805,
	"./pie-chart.png": 4532,
	"./pin.png": 9460,
	"./potted-plant.png": 681,
	"./scatter-graph.png": 3360,
	"./unknown.png": 7247,
	"./video.png": 7124,
	"./virus.png": 6402,
	"./wheat.png": 864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5994;